import React from "react";
import styled from "@emotion/styled";

import PinnedViewsList from "components/my_feed/views_bar/PinnedViewsList";
import Button from "components/ui/button/Button";
import { SavedViewType } from "lib/generated/app-api";
import { EventDataTypes, EventNames, useTracking } from "lib/tracking";

type PinnedViewsProps = {
  pinnedViews: SavedViewType[];
  setIsViewDrawerOpen: (isOpen: boolean) => void;
};

function PinnedViews({ pinnedViews, setIsViewDrawerOpen }: PinnedViewsProps) {
  const { logEvent } = useTracking();

  return (
    <PinnedViewsWrapper>
      <PinnedViewsListScroll>
        <PinnedViewsList pinnedViews={pinnedViews} minified />
      </PinnedViewsListScroll>
      <ViewAllButton
        key={"all_views"}
        onClick={() => {
          setIsViewDrawerOpen(true);
          logEvent(EventNames.allViewsTableOpened, {
            "Data type": EventDataTypes.savedView,
          });
        }}
        buttonType="secondary"
      >
        View all
      </ViewAllButton>
    </PinnedViewsWrapper>
  );
}

const PinnedViewsWrapper = styled.div({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  backgroundColor: "white",
  paddingTop: 8,
  width: "100%",
});

const PinnedViewsListScroll = styled.div({
  flex: 1,
  overflowY: "auto",
});

const ViewAllButton = styled(Button)({
  display: "flex",
  width: "100%",
  flexShrink: 0,
});

export default PinnedViews;
